import {useQueryClient} from '@tanstack/react-query';
import isNumber from 'lodash/isNumber';
import {ReactNode, useMemo} from 'react';
import {DehydratedQueryOptions} from '../common/type';

interface HydrateOptionProps {
  dehydratedOptions?: DehydratedQueryOptions;
  children: ReactNode;
}

/**
 * SSR에서 쿼리를 dehydrate할 경우 상태외에 config(gcTime, staleTime)등은 제거되어
 * 직접 hydrate 하기위해 만든 컴포넌트입니다.
 * https://github.com/TanStack/query/discussions/2443
 */
export function HydrateOption({
  dehydratedOptions,
  children,
}: HydrateOptionProps) {
  const queryClient = useQueryClient();
  /**
   * SSR에서만 hydrate가 동작할 수 있도록 useMemo를 사용했습니다.
   * react-query의 useHydrate를 참고했습니다.
   * https://github.com/TanStack/query/blob/16b7d290c70639b627d9ada32951d211eac3adc3/src/hydration/react.tsx#L12
   */
  useMemo(() => {
    if (dehydratedOptions) {
      queryClient
        .getQueryCache()
        .getAll()
        .forEach(query => {
          const dehydratedOption = dehydratedOptions[query.queryHash];
          if (!dehydratedOption) {
            return;
          }

          /**
           * v5에서는 query 인스턴스의 gcTime 속성만 설정합니다.
           */
          if (isNumber(dehydratedOption.gcTime)) {
            query.gcTime = dehydratedOption.gcTime;
          }
        });
    }
  }, [dehydratedOptions, queryClient]);

  return <>{children}</>;
}
